import R from 'ramda';
import React, { Component } from 'react';
import { Row, Col, FormGroup, Checkbox, Radio } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import getContent from '../ContractBlock/Contents/DisputeResolution';
import getState from '../Deals/DealEditPages/helpers/getState';
import ChangeRequestsView from '../Deals/DealEditPages/ChangeRequestsView';

export default class DisputeResolution extends Component {
  constructor(props) {
    super(props);
    this.state = { adjust: undefined, changes: {} };
  }

  options = () => ({
    field1: this.state.changes.field1,
    field2: this.state.changes.field2,
    field3: this.state.changes.field3,
  });

  componentDidMount() {
    if (this.props.dealBlocks) {
      this.getBlockChanges(this.props.dealBlocks);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dealBlocks) {
      this.getBlockChanges(nextProps.dealBlocks);
    }
  }

  getBlockChanges(dealBlocks) {
    const block = R.find(R.propEq('id', this.props.block.id))(dealBlocks);
    if (block) {
      this.setState({
        changes: block.changes || {},
        adjust: block.accept ? !block.accept : block.changes ? true : undefined,
      });
    }

    // const ownershipBlock = dealBlocks.find(block => block.id === 4);
    // if (ownershipBlock && ownershipBlock.changes && block.accept) {
    //   this.props.removeBlockChanges(this.props.block.id);
    // }
  }

  handleAdjust(adjust) {
    this.setState({ adjust });

    if (!adjust) {
      this.props.removeBlockChanges(this.props.block.id);
    }
  }

  handleContent(field, value) {
    const { contractBlocks, agreementContractBlocks, dealBlocks } = this.props;

    const options = this.options();

    const state = getState(
      false,
      contractBlocks,
      agreementContractBlocks,
      dealBlocks
    );
    options[field] = value;

    if (field === 'field2' && value === true) {
      options.field3 = false;
    } else if (field === 'field3' && value === true) {
      options.field2 = false;
    }

    this.props.setBlockChanges({
      id: this.props.block.id,
      options,
      ...getContent(options, state.field1),
    });
  }

  renderOriginal() {
    let content = '';

    if (this.props.field1 === true) {
      content = `We will try professional mediation.<br />`;
    }
    if (this.props.field2 === true) {
      content += `We agree to binding arbitration.<br />`;
    }
    if (this.props.field3 === true) {
      content += `We will submit our disagreement to a court of law in the region we have chosen.`;
    }

    return content;
  }

  renderAdjust() {
    const { adjust, changes } = this.state;

    if (adjust === true) {
      return (
        <div className="inner-content">
          <FormGroup className="answer">
            <Checkbox
              checked={changes.field1 === true}
              readOnly
              onClick={(e) => this.handleContent('field1', e.target.checked)}
            >
              We will try professional mediation.
            </Checkbox>
            <Checkbox
              checked={changes.field2 === true}
              readOnly
              onClick={(e) => this.handleContent('field2', e.target.checked)}
            >
              We agree to binding arbitration.
            </Checkbox>
            <Checkbox
              checked={changes.field3 === true}
              readOnly
              onClick={(e) => this.handleContent('field3', e.target.checked)}
            >
              We will submit our disagreement to a court of law in the region we
              have chosen.
            </Checkbox>
            <i className="text-gray small">
              Please specify the region in Governing Law tab.
            </i>
          </FormGroup>
        </div>
      );
    } else {
      return null;
    }
  }

  renderChangeRequest(changeRequest) {
    let content = '';

    if (changeRequest.changes.field1 === true) {
      content = `We will try professional mediation.<br />`;
    }
    if (changeRequest.changes.field2 === true) {
      content += `We agree to binding arbitration.<br />`;
    }
    if (changeRequest.changes.field3 === true) {
      content += `We will submit our disagreement to a court of law in the region we have chosen.`;
    }

    return content;
  }

  renderChangeRequests() {
    return (
      <ChangeRequestsView
        changeRequests={this.props.changeRequests}
        renderChangeRequest={(changeRequest) =>
          this.renderChangeRequest(changeRequest)
        }
        isHTML
      />
    );
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>
              <p className="question">
                If a dispute arises, how should it be handled?
              </p>
              <FormGroup className="answer">
                <Radio
                  name="dispute-adjust"
                  checked={this.state.adjust === false}
                  readOnly
                  onClick={(e) => this.handleAdjust(false)}
                >
                  {this.props.userInfo.same
                    ? `Keep my original proposal: `
                    : `Accept ${this.props.userInfo.name} 's proposed terms: `}
                  <div
                    className="pt-7px"
                    dangerouslySetInnerHTML={{ __html: this.renderOriginal() }}
                  ></div>
                </Radio>
                <hr />
                <Radio
                  name="dispute-adjust"
                  checked={this.state.adjust === true}
                  readOnly
                  onClick={(e) => this.handleAdjust(true)}
                >
                  {this.props.userInfo.same
                    ? `Change my proposal:`
                    : `Suggest an alternative:`}
                </Radio>
              </FormGroup>
              {this.renderAdjust()}
              {this.props.renderAccepts()}
              {this.renderChangeRequests()}
            </Col>
          )}
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>{this.props.children}</Col>
          )}

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  This clause outlines the paths collaborators can take to try
                  to resolve any problems between them. Agreeing on this now
                  (before there are any problems) can save you the time and
                  frustration of having to deal with it later when others may be
                  less cooperative.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is mediation?</p>
                <p className="small">
                  Mediation is a voluntary process where both parties and their
                  attorneys work with a neutral third party to reach a
                  resolution. The third party acts as a mediator only and does
                  not decide the outcome of the dispute.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is arbitration?</p>
                <p className="small">
                  Arbitration is a private process that is an alternative to
                  going to court. It involves one or more neutral third parties
                  (arbitrators) that make a binding decision to resolve the
                  dispute. While every dispute may vary, arbitration is
                  generally a faster, confidential, and more cost-effective
                  means of dispute resolution. However, by agreeing exclusively
                  to arbitration, the parties waive their right to a trial by
                  jury, the appeals process, and other rights.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/DealContractBlock/DisputeResolution.jsx